import { format } from 'date-fns'
import { CalendarDaysIcon } from 'lucide-react'
import React, { useEffect, useState } from 'react'

import { Button } from '../ui/button'
import { Calendar } from '../ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover'

import { cn } from '@/lib/utils'

export function DatePicker({ field, required = false }) {
  const [date, setDate] = useState()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setDate(field?.value ?? null)
  }, [field?.value])

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            'justify-start text-left font-normal border bg-white border-input-border-color px-3 py-6 rounded-sm w-full',
            !date && 'text-muted-foreground'
          )}
        >
          {date ? format(date, 'PPP') : <span>Pick a date</span>}
          <CalendarDaysIcon className="ml-auto h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="p-0 rounded-2xl bg-white/20 backdrop-blur-md shadow-xl border w-[100%] md:w-[380px] border-white/30"
        align="start"
      >
        <Calendar
          captionLayout="dropdown-buttons"
          fromYear={1960}
          toYear={2030}
          mode="single"
          selected={date}
          onSelect={(value) => {
            setDate(value)
            field?.onChange(value)
            setOpen(false)
          }}
          initialFocus
          required={required}
          disabled={(date) => date > new Date()}
        />
      </PopoverContent>
    </Popover>
  )
}
